import React, { useContext, useEffect, useState } from 'react'
import { useNavigate, useSearchParams } from 'react-router-dom'

import { loginOTP, acceptTerms } from 'api/auth'

// Components
import LoadingSpinner from 'components/loadingSpinner/LoadingSpinner'
import Logo from 'components/logo'
import PrimaryButton from 'components/primaryButton'
import { ErrorOTP } from 'assets/icons'

// Constant
import { storageKey } from 'constants/storage'
import { UserContext } from 'contexts/user'

// Utils
import storage from 'utils/storage'
import { MeContext } from 'contexts/me'
import ModalContainer from 'components/ModalContainer'
import TermsConditionsContent from 'components/termsConditionsContent/termsConditionsContent'
import PepModal from 'components/PepModal/PepModal'
import { trackEvent } from 'analytics/trackFunctions'

const LoginOTP = () => {
  const [searchParams] = useSearchParams()
  const [termsIdentifier, setTermsIdentifier] = useState()
  const [loading, setLoading] = useState(false)
  const [isError, setIsError] = useState(false)
  const [counter, setCounter] = useState(false)

  const navigate = useNavigate()

  const { setUser, refreshUserToken } = useContext(UserContext)
  const { me, showTC, setShowTc, showPEP, setShowPEP } = useContext(MeContext)

  useEffect(() => {
    if (me) {
      navigate('/home', { replace: true })
    }
  }, [me])

  useEffect(() => {
    const tokenOTP = searchParams.get('otp_token')
    trackEvent({ eventName: 'bille_pantalla_otp' })
    if (tokenOTP) {
      loginOTP(tokenOTP).then((data) => {
        if (data.success) {
          trackEvent({ eventName: 'bille_otp_exitoso', withUTMParams: false })
          storage.set(storageKey.USER, data.data || null)
          setUser(data.data)
        } else {
          trackEvent({
            eventName: 'bille_otp_error',
            withUTMParams: false,
            props: {
              error: data.error?.errors?.otp[0] || ''
            }
          })
          setIsError(true)
          setCounter(15)
        }
      })
    }
  }, [])

  useEffect(() => {
    let interval
    if (isError && counter > 0) {
      interval = setInterval(
        () => setCounter((prevState) => prevState - 1),
        1000
      )
    }
    if (counter === 0) {
      navigate('/', { replace: true })
    }
    return () => clearInterval(interval)
  }, [isError, counter])

  function onAcceptTerms() {
    setLoading(true)
    setShowTc(false)
    acceptTerms({
      application: 'WALLET',
      identifier: termsIdentifier
    }).then(() => {
      refreshUserToken().then(() => {
        setShowTc(false)
        setLoading(false)
      })
    })
  }

  return (
    <div className='flex flex-col h-screen'>
      <header className='shadow-sm w-full h-14 bg-white  md:py-4 flex items-center justify-center'>
        <div className='flex items-center'>
          <Logo showAlways />
        </div>
      </header>
      <div className='mt-20 px-3 h-full w-full max-w-564 mx-auto'>
        {isError ? (
          <section className='flex flex-col items-center md:max-w-564 mx-auto gap-2 h-full'>
            <h1 className='font-bold text-black text-4xl'>¡Oops!</h1>
            <p className='font-bold text-gray-900 text-xl'>
              Ha ocurrido un error
            </p>
            <div className='py-6'>
              <ErrorOTP />
            </div>
            <div className='text-center mx-2 font-medium text-gray-900 text-base leading-relaxed'>
              <p>
                Te redirigiremos al inicio para que vuelvas a intentarlo en{' '}
                <span className='font-bold'>{counter} segundos</span>.
              </p>
              <p className='mt-2'>También podés hacer clic en el botón 👇.</p>
            </div>
            <div className='mt-auto mb-8 max-w-lg'>
              <PrimaryButton
                buttonText='Ir al inicio'
                primaryButtonFunction={() => navigate('/home')}
              />
            </div>
          </section>
        ) : (
          <>
            <div className='mt-10 sm:mt-2'>
              <LoadingSpinner
                width='w-60'
                height='h-60'
                loadingMessage='Estamos validando tus datos'
              />
            </div>
            <p className='text-center font-medium text-gray-900 text-xs mt-2 mb-4'>
              ¡Esperá un toque! Nos tomará un par de segundos 😉
            </p>
          </>
        )}
      </div>

      <ModalContainer
        title='Actualizamos nuestros términos y condiciones'
        isShown={showTC}
        setModalFunction={setShowTc}
        className='!max-w-564 !max-h-[35rem]'
      >
        <TermsConditionsContent
          isModal
          onSelect={() => setShowTc(true)}
          onTermsLoaded={setTermsIdentifier}
        />
        <div className='border-t border-solid border-gray-500 mb-6 mt-3' />
        <div className='flex mt-auto justify-between gap-12'>
          <PrimaryButton
            buttonText='Cancelar'
            primaryButtonFunction={() => {
              setShowTc(false)
              navigate('/')
            }}
            outlined
          />
          <PrimaryButton
            buttonText='Aceptar'
            primaryButtonFunction={() => onAcceptTerms()}
          />
        </div>
      </ModalContainer>

      <PepModal
        isOpen={showPEP}
        setIsOpen={setShowPEP}
        setLoadingPageBtn={setLoading}
        cancelButtonAction={() => {
          navigate('/')
          setShowPEP(false)
        }}
      />
    </div>
  )
}

export default LoginOTP
